import { styled } from '@mui/material';

import { HoverNonBorderTableEditableItemBackground } from 'src/theme/colors';

export const EditableCellValueWrapper = styled('div')({
  padding: 6,
  borderRadius: 4,
  '&:hover': {
    cursor: 'pointer',
    backgroundColor: HoverNonBorderTableEditableItemBackground,
  },
});
